import React from 'react';
import {ADPDialog} from './ADP';
export async function renderADPDialog(root, props) {
    const adpDialogRef: React.RefObject<any> = React.createRef();

    root.render(<ADPDialog ref={adpDialogRef} session={props.session} />);
    return adpDialogRef;
}
